module.exports = __webpack_public_path__ + "img/logo--dark.64501a7d.svg";